<div class="relative bg-white overflow-hidden pt-14 pb-8">
  <div class="mx-auto max-w-7xl relative px-4 sm:px-6 lg:px-8 z-10">
    <h3 class="text-center text-3xl font-display">{{ blok.title }}</h3>
    <p class="text-center text-lg font-body pt-4">{{ blok.subtitle }}</p>
  </div>
</div>